// Reusable shimmer skeleton primitives

export function ShimmerBox({ h = 'h-4', w = 'w-full', rounded = 'rounded', className = '' }) {
  return <div className={`bg-gray-200 animate-pulse ${h} ${w} ${rounded} ${className}`} />;
}

export function ShimmerCircle({ size = 'w-9 h-9', className = '' }) {
  return <div className={`bg-gray-200 animate-pulse rounded-full shrink-0 ${size} ${className}`} />;
}

export function ShimmerStatCard() {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4">
      <div className="flex items-start justify-between mb-3">
        <ShimmerBox h="h-3" w="w-24" />
        <ShimmerBox h="h-9" w="w-9" rounded="rounded-lg" />
      </div>
      <ShimmerBox h="h-7" w="w-20" className="mb-2" />
      <ShimmerBox h="h-3" w="w-16" />
    </div>
  );
}

export function ShimmerTableRow({ cols = 5 }) {
  const widths = ['w-32', 'w-24', 'w-20', 'w-28', 'w-16', 'w-12', 'w-20', 'w-16', 'w-8'];
  return (
    <tr className="border-b last:border-0">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-4 py-3">
          <ShimmerBox h="h-3" w={widths[i % widths.length]} />
        </td>
      ))}
    </tr>
  );
}

export function ShimmerTable({ rows = 6, cols = 5, headers = [] }) {
  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b">
          <tr>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} className="px-4 py-3 text-left">
                <ShimmerBox h="h-3" w="w-16" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <ShimmerTableRow key={r} cols={cols} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ShimmerListItem() {
  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b last:border-0">
      <ShimmerCircle size="w-9 h-9" />
      <div className="flex-1 space-y-2">
        <ShimmerBox h="h-3" w="w-3/4" />
        <ShimmerBox h="h-2.5" w="w-1/2" />
      </div>
      <ShimmerBox h="h-4" w="w-12" rounded="rounded-full" />
    </div>
  );
}

export function ShimmerCard() {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4 space-y-3">
      <div className="flex items-center gap-3">
        <ShimmerBox h="h-10" w="w-10" rounded="rounded-lg" className="shrink-0" />
        <div className="flex-1 space-y-2">
          <ShimmerBox h="h-3" w="w-2/3" />
          <ShimmerBox h="h-2.5" w="w-1/2" />
        </div>
      </div>
      <ShimmerBox h="h-2.5" w="w-full" />
      <ShimmerBox h="h-2.5" w="w-4/5" />
      <ShimmerBox h="h-8" w="w-full" rounded="rounded-lg" />
    </div>
  );
}

export function ShimmerFormField() {
  return (
    <div className="space-y-1.5">
      <ShimmerBox h="h-3" w="w-24" />
      <ShimmerBox h="h-10" w="w-full" rounded="rounded-lg" />
    </div>
  );
}

export function ShimmerChart({ h = 'h-48' }) {
  return <ShimmerBox h={h} w="w-full" rounded="rounded-xl" />;
}
